/**
 * Created by YJZX-LCH on 2017-05-04.
 */
import axios from './axios.js';
import qs from 'qs';

export default {
  // login(username, password, isRemember) {
  //   return axios.post('wedu/v1/sign-in/login', qs.stringify({
  //     'LoginForm[identity]': username,
  //     'LoginForm[password]': password,
  //     'LoginForm[rememberMe]': isRemember ? 1 : 0
  //   })).then((response) => {
  //     if (response.status === 200) {
  //       return response.data;
  //     } else {
  //       throw new Error('接口返回失败');
  //     }
  //   });
  // }
  login(username, password) {
    return axios.post('/jwt/login', qs.stringify(
      {
        'username': username,
        'password': password,
      }
    )).then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('接口返回失败');
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/login.js